import React, { useState, useEffect } from "react";
import ApiService from "../../services/Api.service";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Alert from "../../components/Alert/Alert";
import Pagination from "../../components/Pagination/Pagination";
import StatusBadge from "../../utilities/StatusBadge";
import FilterBar from "../../components/FilterBar/FilterBar";
import Loader from "../../components/Loader/Loader";
import TableSubSection from "./TableSubSection";

export default function AllLeads() {
    const [Loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [sections, setSections] = useState([]);
    const [postsPerPage, setPostsPerPage] = useState(20);
    const [headers, setHeaders] = useState([]);
    const [dropDownData, setDropDownData] = useState([]);
    const [pagination, setPagination] = useState({
        page: 1,
        size: 20,
        total: 0,
        total_pages: 0,
    });
    const [alertValue, setAlertValue] = useState({
        show: false,
        message: "",
        variant: "success",
        position: "middle",
    });
    const [selectedRowIndex, setSelectedRowIndex] = useState(null);
    const [campaignOptions, setCampaignOptions] = useState([]);

    const validationSchema = yup.object().shape({
    });

    const {
        handleSubmit,
        control,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            campaign_id: "",
            agents: [],
            products: [],
            search: "",
            date_from: "",
        }
    });
   const fetchDashboardData = async () => {
        try {
          setLoading(true);
          const campaignRes = await ApiService.getCampaignOptions();
          const campaignData = campaignRes?.data?.data || [];
    
          setCampaignOptions(campaignData);
        } catch (err) {
          console.error("Error loading dashboard data:", err);
        } finally {
          setLoading(false);
        }
      };

  useEffect(() => {
    fetchDashboardData();
  }, []);
    // Dummy options for filters
    const CAMPAIGN_OPTIONS = [
        { label: "FutureSecure Drive", value: "future_secure_drive" },
        { label: "GrowFund Drive", value: "growfund_drive" },
        { label: "PremierProtect", value: "premier_protect" },
        { label: "ShieldSaver Campaign", value: "shieldsaver" },
        { label: "QuickSecure Outreach- B1", value: "quicksecure_b1" },
    ];
    const AGENT_OPTIONS = [
        { label: "Alice Johnson", value: "alice" },
        { label: "Brian Lee", value: "brian" },
        { label: "Clara Singh", value: "clara" },
        { label: "Diego Patel", value: "diego" },
    ];
    const PRODUCT_OPTIONS = [
        { label: "Term Life", value: "term_life" },
        { label: "ULIP", value: "ulip" },
        { label: "HNI", value: "hni" },
    ];

    const fetchDetail = async (page = 1, size = postsPerPage, payload = null) => {
        try {
            setLoading(true);
            if (!payload) {
                payload = {
                    campaign_id:""
                };
            }
            const res = await ApiService.getLeadList(payload, { page, size });
            if (res.status === 200 && res.data) {
                setTableData(res.data.data);
                setPagination(res.data.pagination);
                setHeaders(res.data.header);
                setSections(res.data.sections);
                setSelectedRowIndex(null);
                setLoading(false);
            }
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    };

    const fetchDropdownDetail = async () => {
        try {
            const subprocessRes = await ApiService.getSubprocesses();
            if (subprocessRes.status === 200) setDropDownData(subprocessRes.data)
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchDropdownDetail();
        fetchDetail();
    }, []);

    const handelSubmit = async (data) => {
        // Build payload from filter values (ignore empty strings and empty arrays)
        const payload = Object.fromEntries(
            Object.entries(data).filter(([_, v]) => {
                if (Array.isArray(v)) return v.length > 0;
                return v !== "" && v !== null && v !== undefined;
            })
        );
        fetchDetail(1, postsPerPage, payload);
    };


    const handleClearFilters = () => {
        reset({ campaign_id: "", agents: [], products: [], search: "", date_from: "" });
        fetchDetail();
    };

    const handlePageSizeChange = (e) => {
        const newSize = Number(e.target.value);
        setPostsPerPage(newSize);
        fetchDetail(1, newSize);
        setSelectedRowIndex(null);
    };

    const mistableTh = {
        backgroundColor:"transparent",
        color: "rgba(43, 58, 103, 1)",
        fontFamily: "Nunito",
        fontSize: "12px",
        fontWeight: 700,
        lineHeight: "16px",
        letterSpacing: "0.1em",
        textAlign: "center",
    };

    const tableTdStyles = {
        backgroundColor: "#F7F7F7",
        fontFamily: "Nunito",
        fontSize: "12px",
        fontWeight: "700",
        lineHeight: "16px",
        letterSpacing: "0em",
        textAlign: "center",
        color: "#232122",
    };

    // FilterBar fields (dummy data wired)
    const filterDefs = [
        { type: "text", name: "search", placeholder: "Search..." },
        { type: "select", name: "campaign_id", placeholder: "Select Campaign", options: campaignOptions },
        // { type: "multiselect", name: "agents", placeholder: "Select Agent - All", options: AGENT_OPTIONS },
        // { type: "multiselect", name: "products", placeholder: "Select Product - All", options: PRODUCT_OPTIONS },
        { type: "date", name: "start_date", placeholder: "Start Date" },
        { type: "date", name: "end_date", placeholder: "End Date" },

    ];

    return (
        <> {alertValue.show && (
            <Alert
                variant={alertValue.variant}
                message={alertValue.message}
                dismissible={true}
                timeout={2500}
                position={alertValue.position}
                onClose={() => setAlertValue({ show: false, message: "", variant: "" })}
            />
        )}

            <div className="main-contanier">
                <FilterBar
                    control={control}
                    handleSubmit={handleSubmit}
                    onSubmit={handelSubmit}
                    onClearFilters={handleClearFilters}
                    filters={filterDefs}
                    title={"All Leads"}
                    totalCount={pagination.total || 0}
                    tableId="table-id"
                    isDownload={false}
                />

                <div className="table-container dailymis-table" style={{ height: "400px", position: "relative" }}>
                    {Loading && <Loader fullScreen={false} message="Loading leads..." />}
                    <table id="table-id" className="custom-table-container">
                        <thead
                            className="table-head"
                            style={{ position: "sticky", top: "0", zIndex: "1" }}
                        >
                            <tr>
                                <th style={mistableTh}>S.No</th>
                                {headers.map((header, i) => (
                                    <th key={i} style={mistableTh}>
                                        {header.label}
                                    </th>
                                ))}
                            </tr>
                        </thead>

                        <tbody>
                            {tableData.length > 0 ? (
                                tableData.map((item, index) => (
                                    <React.Fragment key={index}>
                                        <tr
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                                setSelectedRowIndex(selectedRowIndex === index ? null : index)
                                            }
                                        >
                                            <td
                                                style={{
                                                    ...tableTdStyles,
                                                    backgroundColor:
                                                        selectedRowIndex === index ? "#f9faff" : "transparent",
                                                }}
                                            >
                                                {index + 1}
                                            </td>
                                            {headers.map((header, i) => (
                                                <td
                                                    key={i}
                                                    style={{
                                                        ...tableTdStyles,
                                                        backgroundColor:
                                                            selectedRowIndex === index ? "#f9faff" : "transparent",
                                                    }}
                                                    title={item[header.value] ?? "--"}
                                                >
                                                    {header.value === "status" ? (
                                                        <StatusBadge status={item.status} />
                                                    ) : header.value === "disposition" ? (
                                                        <StatusBadge status={item.disposition} />
                                                    ) : (
                                                        item[header.value] ?? "--"
                                                    )}
                                                </td>
                                            ))}
                                        </tr>

                                        {/* Expanded Sub Section */}
                                        {selectedRowIndex === index && (
                                            <tr>
                                                <td colSpan={headers.length + 1}>
                                                    <TableSubSection data={item} sections={sections} />
                                                </td>
                                            </tr>
                                        )}
                                    </React.Fragment>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={headers.length + 2} style={tableTdStyles}>
                                        No data available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <Pagination
                    pagination={pagination}
                    postsPerPage={postsPerPage}
                    handlePageSizeChange={handlePageSizeChange}
                    fetchDetail={fetchDetail}
                />
            </div>

        </>
    );
}
